import React, { useState } from 'react';
import axios from 'axios';
import {
  AppBar, 
  Toolbar, 
  Typography, 
  IconButton, 
  Container,
  Box,
  useMediaQuery,
  Paper,
  Divider
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import BookIcon from '@mui/icons-material/Book';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import SearchBar from './SearchBar';
import BookCard from './BookCard';
import { NetworkDiagram } from './NetworkDiagram';
import BookMetadata from './ BookMetadata';

const App = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [query, setQuery] = useState('');
  const [results, setResults] = useState([]);
  const [generatedGraph, setGeneratedGraph] = useState(null);
  const [selectedNode, setSelectedNode] = useState(null);

  const handleGenerateClick = (graphData) => {
    const filteredLinks = graphData.links.filter(link => link.source && link.target);
    setGeneratedGraph({
      ...graphData,
      links: filteredLinks
    });
    console.log("graphData obtained: ", graphData);
  };

  const handleSearch = async () => {
    try {
      const response = await axios.get(
        `https://rgjkrflnxopeixwpsjae.supabase.co/functions/v1/search`,
        {
          params: { input: query },
          headers: {
            'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InJnamtyZmxueG9wZWl4d3BzamFlIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MTc4MDg1MzAsImV4cCI6MjAzMzM4NDUzMH0.d40jU9GnAyyRugrgmKZeS9aTfAi1_tBCeHzOulyfMAM', 
            'apikey': 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InJnamtyZmxueG9wZWl4d3BzamFlIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MTc4MDg1MzAsImV4cCI6MjAzMzM4NDUzMH0.d40jU9GnAyyRugrgmKZeS9aTfAi1_tBCeHzOulyfMAM',
            'Content-Type': 'application/json',
          },
        }
      );
      setResults(response.data.top10Books);
      console.log("results obtained: ", response.data.top10Books);
      setGeneratedGraph(null);
    } catch (error) {
      console.error('Error fetching books:', error);
      throw error;
    }
  };

  const handleNodeClick = (node) => {
    setSelectedNode(node);
  };

  return (
    <Box sx={{ flexGrow: 1, p: 3 }}>
      <AppBar position="static" color="transparent" elevation={0}>
        <Toolbar>
          <IconButton color="inherit" aria-label="bookshelves">
            <MenuBookIcon />
          </IconButton>
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            Connected Books
          </Typography>
          {/* {!isMobile && (
            <>
              <IconButton color="inherit" aria-label="bookshelves">
                <MenuBookIcon />
              </IconButton>
              <IconButton color="inherit" aria-label="book of the day">
                <BookIcon />
              </IconButton>
            </>
          )} */}
        </Toolbar>
      </AppBar>
      <Container maxWidth="sm">
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '10vh',
            textAlign: 'center',
          }}
        >
          <Typography 
            variant="h2" 
            component="h1" 
            gutterBottom
            sx={{
              fontFamily: '"Times New Roman"',
              fontWeight: 700,
            }}
          >
            Connected Books
          </Typography>
          <Typography 
            variant="h5" 
            gutterBottom
            sx={{
              fontFamily: '"Verdana"',
              fontWeight: 400,
              mb: 4,
            }}
          >
            Search for your book through a phrase or subject describing the book and generate a graph to discover similar books.
          </Typography>
          <SearchBar query={query} setQuery={setQuery} handleSearch={handleSearch} />
          
          
          
        </Box>
      </Container>
      <Container maxWidth="md">
      {(!generatedGraph && results.length > 0) && (
            results.map((book, index) => (
              <BookCard 
                key={index} 
                book={book} 
                onGenerateClick={handleGenerateClick}
              />
            ))
          )}
      </Container>
      <Container maxWidth="lg">

      {generatedGraph && (
        <Paper elevation={3} sx={{ p: 2, mt: 4 }}>
          <Box sx={{ width: '100%', height: 500, mb: 2 }}>
            <NetworkDiagram
              width={1000}
              height={400}
              data={generatedGraph}
              collideRadius={40}
              manyBodyStrength={-10}
              forceYStrength={0.5}
              onNodeClick={handleNodeClick}
              selectedNode={selectedNode}
            />
          </Box>
          <Divider sx={{ my: 2 }} />
          {selectedNode ? (
            <BookMetadata book={selectedNode} />
          ) : (
            <Typography variant="body1" color="text.secondary">
              Click on a node in the network to see book details.
            </Typography>
          )}
        </Paper>
      )}
        </Container>
      
    </Box>
  );
};

export default App;